export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    showPatientWaitingTable({commit}) {
        commit('showPatientWaitingTable');
    },
    showOccupationHealthDoctorAppointment({commit}) {
        commit('showOccupationHealthDoctorAppointment');
    },
    showPatientDisband({commit}) {
        commit('showPatientDisband');
    },
    showPatientAttendanceTable({commit}) {
        commit('showPatientAttendanceTable');
    },
    showPatientAttendanceDetails({commit}) {
        commit('showPatientAttendanceDetails');
    },
}
